module.exports = __webpack_public_path__ + "img/Sign_up.b59ac11c.svg";